import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "../../api/client";

export const fetchFaqs = createAsyncThunk(
  "faq/fetchFaqs",
  async (_, thunkApi) => {
    const res = await apiRequest("api/faqs", { method: "GET" });

    if (!res.ok) {
      const errors = Array.isArray(res.data?.errors) ? res.data.errors : null;
      return thunkApi.rejectWithValue(
        errors?.join("\n") || res.data?.message || "Failed to load FAQs."
      );
    }

    const items = Array.isArray(res.data) ? res.data : [];
    const sorted = [...items].sort(
      (a, b) => (a.position ?? 0) - (b.position ?? 0)
    );

    return sorted;
  },
  {
    condition: (_, { getState }) => {
      const state = getState();
      const faqState = state?.faq;
      if (!faqState) return true;
      return faqState.status === "idle" || faqState.status === "failed";
    },
  }
);

const faqSlice = createSlice({
  name: "faq",
  initialState: {
    status: "idle", // idle | loading | succeeded | failed
    error: "",
    items: [],
  },
  reducers: {
    clearFaqs(state) {
      state.status = "idle";
      state.error = "";
      state.items = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFaqs.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(fetchFaqs.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = "";
        state.items = action.payload || [];
      })
      .addCase(fetchFaqs.rejected, (state, action) => {
        state.status = "failed";
        state.error =
          typeof action.payload === "string" ? action.payload : "Failed to load FAQs.";
        state.items = [];
      });
  },
});

export const { clearFaqs } = faqSlice.actions;
export default faqSlice.reducer;

